import React  from 'react';
import {  Link } from 'react-router-dom';
import AboutHome from '../components/AboutHome';
import PopularProducts from '../components/PopularProducts';
import SpecialOfferProducts from '../components/SpecialOfferProducts';
import BlogsHome from '../components/BlogsHome';
import WhyChooseHome from '../components/WhyChooseHome';

import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import Slider from '../common/Slider';
import MobileMenu from '../common/MobileMenu';
import {api_base_url, base_url} from '../common/Constants';
 
class Home extends React.Component{

    constructor(){
        super();
        this.state = {
            categories : [],
            page_content:[],
            loading:1,
            banners:[],
            banner_loaded : 0
        }
    }
      
    
    componentDidMount()
    {
        this.setState({banners:JSON.parse(localStorage.getItem("banners"))}) ;
        this.setState({categories:JSON.parse(localStorage.getItem("categories"))}) ;  
        this.setState({page_content:JSON.parse(localStorage.getItem("page_content"))}); 
        this.setState({loading:0}) ;   
    }


    render()
    {
        if (this.state.loading == 1) return <div class="loader">Loading...</div>;
        return (
<div>
            <div className="page-wrapper">
      <Header/> 

        <Slider banners={this.state.banners}/>
         

        <AboutHome  categories={this.state.categories}/> 
        
        <PopularProducts/>
        <div class="ul-container">
            <section class="ul-ad">
                <div class="ul-inner-container">
                    <div class="ul-ad-content">
                        <div class="ul-ad-txt">
                            <span class="ul-ad-sub-title">Trending Products</span>
                            <h2 class="ul-section-title">Get 30% Discount On All Hudis!</h2>
                    
                        </div>


                        <Link to={base_url+"shop"} class="ul-btn">Shop Now<i class="flaticon-up-right-arrow"></i></Link>
                    </div>
                </div>
            </section>
        </div>
       <SpecialOfferProducts/>
       
        <Footer/>
       {/**** <BlogsHome/> <WhyChooseHome />

       
       
  */} 
      </div>
       
       </div>
      
       
        )
    }

}
export default Home;